<template>
	<div class="homePicker">
		<div class="homePicker__cont">
			<div class="homePicker__left">
				<div class="homePicker__top button">
					<div class="redactorStyles">
						<h2>{{ leftHeader }}</h2>
					</div>
					<div class="buttons">
						<a :href="`${leftLink}`" class="secBtn homePicker__viewAll">
							<p>{{ leftLinkText }}</p>
						</a>
					</div>
				</div>

				<EventPicker
					class="homePicker__dp datePick"
					v-model="datePicked"
					:disabled-dates="this.vueDatepickerOptions[0]"
					model-type="yy-m-d"
					inline
					auto-apply
				></EventPicker>
			</div>
			<div class="homePicker__right">
				<div
					class="homePicker__top homePicker__top--right redactorStyles button darkText"
				>
					<h2 class="homePicker__h2 redactorStyles">{{ rightHeaderValue }}</h2>
					<div
						v-if="
							(displayEvents && displayEvents.length > 2) ||
							(displayEvents && displayEvents.length == 2 && windowWidth < 1300)
						"
						class="homePicker__buttons"
					>
						<button @click="previous">
							<img :src="svgLeft" />
						</button>
						<button @click="next">
							<img :src="svgRight" />
						</button>
					</div>
				</div>
				<div class="homePick__events">
					<VueSlickCarousel
						ref="carousel"
						v-bind="slickOptions"
						:key="carouselKey"
						v-if="displayEvents && displayEvents.length > 0"
					>
						<div
							v-for="(event, index) in displayEvents"
							:key="event.id"
							class="homeEvent"
						>
							<div class="homeEvent__top">
								<a
									tabindex="0"
									:href="`${event.url}?date=${event.urlDate}&time=${event.urlTime}`"
								>
									<div class="homeEvent__imgCont">
										<div
											class="eFilter__badgeCont"
											v-if="
												(event.badges && event.badges.length > 0) ||
												event.cancelled ||
												event.soldOut
											"
										>
											<div v-if="event.cancelled" class="eFilter__badge--red">
												<p>Cancelled</p>
											</div>
											<div v-if="event.soldOut" class="eFilter__badge--red">
												<p>Sold out</p>
											</div>

											<div
												v-if="event.badges && event.badges.length > 0"
												v-for="(badge, index) in event.badges"
											>
												<div
													v-if="badge === 'Cancelled' || badge === 'Sold out'"
													class="eFilter__badge--red"
												>
													<p>{{ badge }}</p>
												</div>
												<div v-else class="eFilter__badge">
													<p>{{ badge }}</p>
												</div>
											</div>
										</div>
										<img :src="`${event.image}`" :alt="`${event.title}`" />
									</div>
								</a>
								<div class="redactorStyles">
									<h5 class="homeEvent__h4">{{ event.title }}{{ event.id }}</h5>
									<p class="homeEvent__p">
										{{ event.dayOfWeek }}, {{ event.month }}
										{{ event.dayOfMonth }}, {{ event.year }}
										<span v-if="event.endTime">from</span
										><span v-else>at</span> {{ event.time
										}}<span v-if="event.endTime"
											>&#8212;{{ event.endTime }}</span
										>
									</p>
								</div>
							</div>
							<div class="buttons">
								<div class="prmBtn prmBtn--darkOutline">
									<a
										tabindex="0"
										:href="`${event.url}?date=${event.urlDate}&time=${event.urlTime}`"
									>
										<p>Learn More</p>
									</a>
								</div>
							</div>
						</div>
					</VueSlickCarousel>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import VueSlickCarousel from 'vue-slick-carousel';

export default {
	name: 'HomeEventPicker',
	props: {
		svgLeft: String,
		svgRight: String,
		leftLinkText: String,
		leftLink: String,
		leftHeader: String,
		rightHeader: String,
	},
	data() {
		return {
			rightHeaderValue: this.rightHeader,
			daysOfTheWeek: [
				'Sunday',
				'Monday',
				'Tuesday',
				'Wednesday',
				'Thursday',
				'Friday',
				'Saturday',
			],
			monthsOfTheYear: [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			],
			slickOptions: {
				slidesToScroll: 1,
				infinite: false,
				touchMove: true,
				speed: 500,
				cssEase: 'ease',
				easing: 'linear',
				accessibility: true,
				autoplay: false,
				draggable: true,
				swipe: true,
				arrows: true,
				edgeFriction: 0.0004,
				touchThreshold: 100,
				variableWidth: true,
			},
			allIds: [],
			datePicked: null,
			carouselKey: false,
			displayEvents: 0,
			rawData: [],
			mappedEvents: null,
			windowWidth: null,
			today: null,
			endDate: null,
			validDates: [],
			invalidDates: [],
			vueDatepickerOptions: [
				{
					to: new Date(),
					dates: [],
				},
			],
		};
	},
	components: {
		EventPicker: Datepicker,
		VueSlickCarousel,
	},
	mounted() {
		this.window();
		let that = this;
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.window();
			});
		});
	},
	beforeMount() {
		this.getEvents();
		this.getStartDates();
	},
	methods: {
		window() {
			this.windowWidth = $(window).width();
		},
		next() {
			this.$refs.carousel.next();
		},
		previous() {
			this.$refs.carousel.prev();
		},
		getStartDates() {
			let today = new Date();
			today.setHours(0, 0, 0, 0);
			today = today.setDate(today.getDate() - 1);
			this.today = new Date(today);
			this.vueDatepickerOptions[0].to = new Date(today);

			let todayPlus = new Date();
			todayPlus.setHours(0, 0, 0, 0);
			this.endDate = new Date(todayPlus.setMonth(todayPlus.getMonth() + 9));
			this.$forceUpdate();
		},
		getEvents() {
			let that = this;
			$.get('/api/v1/eventshome', function (res) {
				that.rawData = res.data;
			});
		},
		mapDateHelper(dateTimeString) {
			// Split the input date-time string at the space character
			const [datePart, timePart] = dateTimeString.split(' ');

			// Split the date part into year, month, and day
			const [year, month, day] = datePart.split('-');

			// Split the time part into hours, minutes, and seconds
			const [hours, minutes, seconds] = timePart.split(':');

			// Create a new Date object
			const dateObject = new Date(
				year,
				month - 1,
				day,
				hours,
				minutes,
				seconds
			);

			return dateObject;
		},
		validDateHelper(inputDate) {
			let dateParts = inputDate.split(' ');
			let abbreviatedDate = dateParts[0];
			// Split the input date string into its components
			const [year, month, day] = abbreviatedDate.split('-');

			// Create a new Date object
			const date = new Date(year, month - 1, day);

			// Define arrays for days of the week and months
			const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
			const months = [
				'Jan',
				'Feb',
				'Mar',
				'Apr',
				'May',
				'Jun',
				'Jul',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			];

			// Get the components of the formatted date
			const dayOfWeek = daysOfWeek[date.getDay()];
			const monthName = months[date.getMonth()];
			const formattedDay = String(date.getDate()).padStart(2, '0');
			const formattedYear = date.getFullYear();
			const formattedHours = String(date.getHours()).padStart(2, '0');
			const formattedMinutes = String(date.getMinutes()).padStart(2, '0');
			const formattedSeconds = String(date.getSeconds()).padStart(2, '0');
			const timezoneOffset = date.getTimezoneOffset();
			const timezoneOffsetHours = Math.abs(Math.floor(timezoneOffset / 60))
				.toString()
				.padStart(2, '0');
			const timezoneOffsetMinutes = (Math.abs(timezoneOffset) % 60)
				.toString()
				.padStart(2, '0');
			const timezoneOffsetSign = timezoneOffset > 0 ? '-' : '+';

			// Construct the formatted date string
			let formattedDate = `${dayOfWeek} ${monthName} ${formattedDay} ${formattedYear} ${formattedHours}:${formattedMinutes}:${formattedSeconds} GMT${timezoneOffsetSign}${timezoneOffsetHours}${timezoneOffsetMinutes}`;
			formattedDate = new Date(formattedDate);
			return formattedDate;
		},
		getValidDates() {
			let today = new Date();
			today = today.setDate(today.getDate() - 1);
			today = new Date(today);
			let dateArray = [];
			this.rawData.forEach((elem) => {
				elem.dateMatrix.matrixBlock.forEach((item) => {
					let itemDate = this.validDateHelper(item.eventDateTime.date);
					if (itemDate > today) {
						dateArray.push(itemDate.getTime());
					}
				});
			});
			this.validDates = dateArray;
		},
		tConvert(time) {
			// Check correct time format and split into components
			time = time
				.toString()
				.match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

			if (time.length > 1) {
				// If time format correct
				time = time.slice(1); // Remove full string match value
				time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
				time[0] = +time[0] % 12 || 12; // Adjust hours
			}

			return time.join(''); // return adjusted time or original string
		},
		getPickedEvents(newDate) {
			let dummyArray = this.mappedEvents;
			let events = [];
			dummyArray.filter((event) => {
				if (event.matchDate == newDate) {
					events.push(event);
				}
			});

			this.displayEvents = events.sort(function (a, b) {
				return new Date(a.presentationDate) - new Date(b.presentationDate);
			});
			this.$forceUpdate();
		},
		setRightHeader(pickeddate) {
			if (pickeddate === null) {
				return;
			}

			let date = moment(new Date(pickeddate), 'YYYY-MM-DD HH:mm:ss');
			let day = date.format('dddd');
			let month = this.monthsOfTheYear[moment(date).month()];
			if (month !== 'July' || month !== 'June') {
				month = this.monthsOfTheYear[moment(date).month()];
			}
			let number = moment(date).date();
			// let year = moment(date).year();
			if (day !== undefined) {
				this.rightHeaderValue = day + ', ' + month + ' ' + number;
			}
		},
		mapEvents() {
			if (this.rawData) {
				let arrayAll = [];
				this.rawData.forEach((item) => {
					let badges = [];
					if (item.badges.length > 0) {
						item.badges.forEach((badge) => {
							if (badge.chooseABadge) {
								badges.push(badge.chooseABadge.label);
							} else if (badge.badgeText) {
								badges.push(badge.badgeText);
							}
						});
					}
					arrayAll.push(
						item.dateMatrix.matrixBlock.map((dateItem, index) => {
							const presentationDate = this.mapDateHelper(
								dateItem.eventDateTime.date
							);
							const matchDate = this.validDateHelper(
								dateItem.eventDateTime.date
							).getTime();
							const dateUrlString = new Date(presentationDate);
							const dateUrl = dateUrlString
								.toLocaleDateString('en-US', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								})
								.replaceAll('/', '-');
							let time = this.tConvert([
								moment(new Date(presentationDate)).format('h:mm a'),
							]);
							let urlTime = moment(dateItem.eventDateTime.date).format('hh:mm');
							time = time.replace(':00', '');
							let endTime = null;
							if (dateItem.eventEndDate) {
								const end = this.mapDateHelper(dateItem.eventEndDate.date);
								endTime = this.tConvert([moment(end).format('h:mm a')]);
								endTime = endTime.replace(':00', '');
							} else {
								endTime = null;
							}
							if (
								endTime !== null &&
								((time.includes('am') && endTime.includes('am')) ||
									(time.includes('pm') && endTime.includes('pm')))
							) {
								time = time.slice(0, -3);
							}
							return {
								title: item.title,
								url: item.url,
								image: item.image,
								presentationDate,
								matchDate,
								year: new Date(presentationDate).getFullYear(),
								dayOfWeek:
									this.daysOfTheWeek[new Date(presentationDate).getDay()],
								dayOfMonth: new Date(presentationDate).getDate(),
								month:
									this.monthsOfTheYear[new Date(presentationDate).getMonth()],
								time: time,
								endTime: endTime,
								urlDate: dateUrl,
								urlTime: urlTime,
								cancelled: dateItem.cancelled,
								soldOut: dateItem.soldOut,
								tessId: dateItem.tessId,
								badges: badges,
							};
						})
					);
				});

				arrayAll = Array.prototype.concat.apply([], arrayAll);
				const yesterday = new Date();
				yesterday.setDate(yesterday.getDate() - 1);
				yesterday.setHours(0, 0, 0, 0);

				// Filter presentations with dates on or after yesterday
				this.mappedEvents = arrayAll.filter((presentation) => {
					const presentationDate = new Date(presentation.presentationDate);
					return presentationDate >= yesterday;
				});

				this.mappedEvents.forEach((item) => {
					if (item.tessId !== null) {
						this.allIds.push(item.tessId);
					}
				});
			}
		},
	},

	watch: {
		datePicked(date) {
			if (date === null || this.mapEvents === null) {
				return;
			}
			if (typeof this.datePicked === 'object') {
				let newDate = new Date(this.datePicked).getTime();
				console.log(newDate);
				this.getPickedEvents(newDate);
			} else {
				this.getPickedEvents(this.datePicked);
			}
			this.setRightHeader(this.datePicked);
		},
		rawData(rawData) {
			if (this.rawData.length > 0) {
				this.mapEvents();
				this.getValidDates();
			}
		},
		mappedEvents(events) {
			if (this.mappedEvents !== null) {
				const ids = this.allIds.join(',').toString();
				let that = this;
				$.get(
					'/actions/my-module/default/available-tickets-check',
					{ arrayOfIds: ids },
					function (res) {
						let jsonRes = JSON.parse(res);
						Object.values(jsonRes).forEach((performance) => {
							that.mappedEvents.forEach((event) => {
								let performanceId = performance.PerformanceId.toString();
								if (event.tessId === performanceId) {
									// Check for matching tessId and PerformanceId and update soldOut status
									event.soldOut =
										performance.AvailableCount === 0 ? true : false;
								}
							});
						});
					}
				);
			}
		},
		displayEvents(events) {
			this.carouselKey += 1;
		},
		validDates(n) {
			if (this.validDates.length == 0) {
				return;
			}
			let valid = [];
			for (
				var arr = [], dt = new Date(this.today);
				dt <= new Date(this.endDate);
				dt.setDate(dt.getDate() + 1)
			) {
				// gives datepicker dates to block out.
				if (this.validDates.indexOf(new Date(dt).getTime()) === -1) {
					this.vueDatepickerOptions[0].dates.push(new Date(dt));
					arr.push(new Date(dt));
				} else {
					valid.push(new Date(dt));
				}
			}
			valid = valid.sort((a, b) => b.date - a.date);
			// assigns the first date the datepicker should start on
			this.datePicked = new Date(valid[0]).setHours(0, 0, 0, 0);
		},
	},
};
</script>
